import { Component } from 'preact';
import PropTypes from 'prop-types';
import {
  setFiltersList,
  incrementFilter,
  setComponentsExhibition,
  addFilter,
  removeFilter,
  setFilter,
  setList,
  resetFilter,
} from '%/stores/Filters/UsedVehicles/FilterV3';
import { setActiveUnit } from '%/stores/CurrentStockUnit';
import { parseFiltersStoreStateToComponentState } from '%/utils/filters/usedVehicles/parseFiltersStoreStateToComponentState';
import { applyURLSearchParams } from '%/utils/filters/usedVehicles/applyURLSearchParams';
import { mapFiltersV2 } from '%/utils/filters/usedVehicles/mapFiltersV2';
import { restoreFilterFromURLParams } from '%/utils/filters/usedVehicles/restoreFilterFromURLParams';
import FilterFooter from './components/FilterFooter';
import SimpleFilter from './components/SimpleFilter';
import { setOptions } from '../../../stores/Filters/UsedVehicles/FilterV3Options';

class MainFilterV3App extends Component {
  constructor(props) {
    super(props);

    this.setInitialFilters = this.setInitialFilters.bind(this);
    this.setUnitChoicedFilter = this.setUnitChoicedFilter.bind(this);
    this.watchStore = this.watchStore.bind(this);
    this.updateStateFromStore = this.updateStateFromStore.bind(this);
  }

  componentDidMount() {
    this.setInitialFilters();
    this.setUnitChoicedFilter();
    setOptions();
    this.watchStore();
  }

  setInitialFilters() {
    restoreFilterFromURLParams({
      setFiltersList,
      setList,
      setComponentsExhibition,
    });
  }

  setUnitChoicedFilter() {
    const currentStockUnitState = window.store.CurrentStockUnit.getState();
    if (currentStockUnitState) {
      const currentUnit = currentStockUnitState.currentUnit;

      if (currentUnit) {
        addFilter({
          key: mapFiltersV2.units,
          value: currentUnit.id.toString(),
        });
        setList();
      }
    }

    window.store.CurrentStockUnit.watch(setActiveUnit, state => {
      const { currentUnit } = state;

      if (currentUnit) {
        setFilter({
          key: mapFiltersV2.units,
          value: currentUnit.id.toString(),
        });
      } else {
        removeFilter(mapFiltersV2.units);
      }

      setList();
    });
  }

  updateStateFromStore(state) {
    const { filtersList } = state;
    if (!filtersList) return;

    const parsedFiltersList =
      parseFiltersStoreStateToComponentState(filtersList);
    applyURLSearchParams(parsedFiltersList);
  }

  watchStore() {
    window.store.UsedVehiclesFilter.watch(
      incrementFilter,
      this.updateStateFromStore,
    );
    window.store.UsedVehiclesFilter.watch(setFilter, this.updateStateFromStore);
    window.store.UsedVehiclesFilter.watch(
      removeFilter,
      this.updateStateFromStore,
    );
    window.store.UsedVehiclesFilter.watch(
      resetFilter,
      this.updateStateFromStore,
    );
  }

  render() {
    const { defaultSort, showSpecialOffers } = this.props;

    return (
      <div className="filter-v2">
        <SimpleFilter showSpecialOffers={showSpecialOffers} />
        <FilterFooter defaultSort={defaultSort} />
      </div>
    );
  }
}

MainFilterV3App.defaultProps = {
  defaultSort: null,
  showSpecialOffers: false,
};

MainFilterV3App.propTypes = {
  defaultSort: PropTypes.string,
  showSpecialOffers: PropTypes.bool,
};

export default MainFilterV3App;
